import React from 'react'

const StatusHeader = ({judgemental, lang}) => {
  return !judgemental ? (
      <div className='col-md-12 col-sm-12 col-xs-12' style={{'padding': '20px 5px'}}>
        <div className='col-md-6 col-sm-6 col-xs-4'>
        </div>
        <div className='col-md-3 col-sm-3 col-xs-4' style={{ 'textAlign': 'center' }}>
          { lang.q360_status_percentage_text }
        </div>
        <div className='col-md-3 col-sm-3 col-xs-4' style={{ 'textAlign': 'center'}}>
          { lang.q360_status_allocated_points }
        </div>
      </div>
  ) : <div></div>
}

export default StatusHeader;
